var MediaQueryDispatch = require('./MediaQueryDispatch');
module.exports = new MediaQueryDispatch();



//////////////////
// WEBPACK FOOTER
// ../node_modules/enquire.js/src/index.js
// module id = 400
// module chunks = 2 3 11 12